export default "__VITE_ASSET__CaBOfJv3__"